import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { intlMessageShape } from 'sb-react-intl'

import Title from 'components/_new/typography/deprecated/Title/Title'
import Text from 'components/_new/typography/Text/Text'

import s from './Headline.scss'


const Headline = (props) => {
  const {
    className,
    subTitleClassName,
    supTitle,
    title, titleTag,
    subTitle, subTitleTag,
    size, icon, iconColor,
    titleValues, subTitleValues,
    withMargin = true,
    mutedSupTitle = true,
    mutedSubTitle = true,
  } = props

  const headlineClassName = cx(className, {
    [s[`margin-${size}`]]: withMargin && size,
  })

  return (
    <div className={headlineClassName}>
      {
        Boolean(supTitle) && (
          <Text message={supTitle} muted={mutedSupTitle} html />
        )
      }
      {
        Boolean(title) && (
          <Title
            message={title}
            withMargin={false}
            tag={titleTag}
            size={size}
            icon={icon}
            iconColor={iconColor}
            values={titleValues}
            html
          />
        )
      }
      {
        Boolean(subTitle) && (
          <Text
            className={cx(s.subTitle, subTitleClassName)}
            message={{ ...subTitle, values: subTitleValues }}
            tag={subTitleTag}
            muted={mutedSubTitle}
            html
          />
        )
      }
    </div>
  )
}

const messagePropType = PropTypes.oneOfType([
  PropTypes.shape(intlMessageShape),
  PropTypes.string,
])

Headline.propTypes = {
  className: PropTypes.string,
  supTitle: messagePropType,
  title: messagePropType,
  titleTag: PropTypes.string,
  subTitle: messagePropType,
  subTitleTag: PropTypes.string,
  size: PropTypes.oneOf([ 'sm', 'md', 'lg', 'xlg' ]),
  icon: PropTypes.string,
  iconColor: PropTypes.string,
  titleValues: PropTypes.object,
  subTitleValues: PropTypes.object,
  mutedSupTitle: PropTypes.bool,
  mutedSubTitle: PropTypes.bool,
}


export default Headline
